import { useMutation } from "@tanstack/react-query";
import { useToast } from "@packsize/toast";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { reproducePackagingSolution } from "@/api/audit-api";

export interface UseReproducePackagingSolutionOptions {
	onSuccess?: () => void;
}

export const useReproducePackagingSolution = (
	packagingSolutionId: string,
	options?: UseReproducePackagingSolutionOptions,
) => {
	const intl = useIntl();
	const navigate = useNavigate();
	const { toastSuccess, toastError } = useToast();

	const mutation = useMutation({
		mutationFn: () => reproducePackagingSolution(packagingSolutionId),
		onSuccess: (response) => {
			const message = intl.formatMessage(
				{
					id: "{alias} sent to queue",
					defaultMessage: "{alias} sent to queue",
				},
				{ alias: response.data.alias },
			);

			toastSuccess({
				title: message,
				message: intl.formatMessage({ id: "Click here to view", defaultMessage: "Click here to view" }),
				onClick: () => navigate("/production/orders"),
			});

			options?.onSuccess?.();
		},
		onError: () => {
			toastError({
				message: intl.formatMessage({
					id: "Failed to reproduce",
					defaultMessage: "Failed to reproduce",
				}),
			});
		},
	});

	return {
		reproduce: () => mutation.mutate(),
		isReproducing: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
	};
};
